<div class="search-wrapper">
  <div class="search">
    <mat-form-field appearance="outline" class="hide-subscript">
      <input
        type="text"
        matInput
        [formControl]="searchControl"
        (ngModelChange)="onSearchInput($event)"
        placeholder="Search Site Hierarchy"
        i18n-placeholder />
      @if (searchControl.value?.length === 0) {
        <button matSuffix mat-icon-button>
          <mat-icon>search</mat-icon>
        </button>
      }
      @if (searchControl.value?.length > 0) {
        <button matSuffix mat-icon-button (click)="searchControl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>
</div>
@if (!emptyFilters && site?.meta?.['visibleSublocations'] === 0) {
  <div class="search-status">
    <p><ng-container i18n>No Result Found</ng-container></p>
  </div>
}

<div class="badges">
  <div class="badge-filters">
    @for (badge of badges; track badge.title) {
      <filter-badge
        [active]="badge.active"
        [count]="badge.count"
        [title]="badge.title"
        [showFilterCount]="false"
        (click)="onBadgeClick(badge)"></filter-badge>
    }
  </div>
</div>

@if (!fetchingHierarchy) {
  <div class="hierarchy" (click)="$event.stopPropagation()">
    <div class="header">
      @if (regionStream$ | async; as regionStream) {
        @if (regionStream.hasRegions) {
          <div class="region-container">
            <img [src]="'Location' | icon: 'Icon'" class="sidebar-icon" />
            <div>
              {{
                region?.name === 'Unassigned' ? 'Default Region' : region?.name
              }}
            </div>
          </div>
        }
        @if (!regionStream.hasRegions) {
          <div class="company-container">
            <img
              [src]="'Company Management' | icon: 'Icon'"
              class="sidebar-icon" />
            <a (click)="navigateToHierarchyItem(company)">{{
              company?.name
            }}</a>
          </div>
        }
      }
      <div>
        <button (click)="expandAllHierarchy(false)">
          <i class="pi pi-angle-up"></i>
        </button>
        <button (click)="expandAllHierarchy(true)">
          <i class="pi pi-angle-down"></i>
        </button>
      </div>
    </div>
    <div #accordionWrapper class="accordion-wrapper">
      <div class="site-container">
        <a
          class="ellipsis"
          [routerLink]="['/dashboard/' + site?.id]"
          (click)="navigateToHierarchyItem(site); $event.stopPropagation()">
          <span
            class="ellipsis"
            matTooltipPosition="above"
            mat-raised-button
            matTooltip="{{ site?.name }}"
            [matTooltipDisabled]="isTooltipDisabled(toolTip)"
            matTooltipClass="customToolTip"
            #toolTip>
            {{ site?.name }}
          </span>
        </a>
        @if (site?.meta?.['isPaused']) {
          <img
            style="width: 1.4rem; filter: brightness(10)"
            src="assets/icons/under-maintenance-icon.svg" />
        }
      </div>
      @for (sublocation of sublocations; track sublocation.id) {
        @if (
          sublocation.meta['matchesFilter'] ||
          sublocation.meta['childMatchesFilter']
        ) {
          <div
            class="sublocation-container"
            (click)="toggleHierarchyItem(sublocation)">
            <a
              class="sublocation-text ellipsis"
              [routerLink]="['/dashboard/' + sublocation.id]"
              (click)="
                navigateToHierarchyItem(sublocation); $event.stopPropagation()
              ">
              <span
                class="ellipsis"
                matTooltipPosition="above"
                mat-raised-button
                matTooltip="{{ sublocation.name }}"
                [matTooltipDisabled]="isTooltipDisabled(toolTip)"
                matTooltipClass="customToolTip"
                #toolTip>
                {{ sublocation.name }}
              </span>
            </a>
            <div class="online-status">
              @if (sublocation.meta['isPaused']) {
                <img
                  style="margin-right: 0.2rem"
                  src="assets/icons/under-maintenance-icon.svg" />
              }
              <i
                class="pi pi-angle-up caret-icon"
                [ngClass]="{ expanded: sublocation.meta['isExpanded'] }"></i>
            </div>
          </div>
        }
        @if (
          emptyFilters
            ? sublocation.meta['isExpanded']
            : sublocation.meta['childMatchesFilter']
        ) {
          @for (asset of sublocation.assets; track asset.id) {
            @if (
              asset.meta['matchesFilter'] || asset.meta['childMatchesFilter']
            ) {
              <div
                class="asset-container"
                [ngClass]="{ 'inactive-mask': asset.inactive }"
                (click)="toggleHierarchyItem(asset)">
                <a
                  class="asset-text ellipsis"
                  [routerLink]="['/assets/' + asset.id + '/health']"
                  (click)="
                    navigateToHierarchyItem(asset); $event.stopPropagation()
                  ">
                  @if (asset.alertStatus === AlertStatus.Clear) {
                    <span>
                      <img
                        fxFlex
                        class="icon"
                        [src]="'assets/icons/clear-icon.svg'" />
                    </span>
                  } @else {
                    <span fxFlex>
                      <img
                        fxFlex
                        class="icon"
                        [src]="
                          'assets/icons/' + asset.alertStatus + '-icon.svg'
                        " />
                    </span>
                  }
                  <span
                    class="ellipsis"
                    matTooltipPosition="above"
                    mat-raised-button
                    matTooltip="{{ asset.name }}"
                    [matTooltipDisabled]="isTooltipDisabled(toolTip)"
                    matTooltipClass="customToolTip"
                    #toolTip>
                    {{ asset.name }}
                  </span>
                </a>
                <div class="online-status">
                  @if (asset.meta['isPaused']) {
                    <img
                      style="margin-right: 0.2rem"
                      src="assets/icons/under-maintenance-icon.svg" />
                  }
                  <i
                    class="pi pi-angle-up caret-icon"
                    [ngClass]="{ expanded: asset.meta['isExpanded'] }"></i>
                </div>
              </div>
            }
            @if (
              emptyFilters
                ? asset.meta['isExpanded']
                : asset.meta['childMatchesFilter']
            ) {
              @for (
                monitoringPoint of asset.monitoringPoints;
                track monitoringPoint.id
              ) {
                @if (monitoringPoint.meta['matchesFilter']) {
                  <div
                    class="monitoring-point-container"
                    [ngClass]="{ 'inactive-mask': monitoringPoint.inactive }">
                    <a
                      class="monitoring-point-text ellipsis"
                      [routerLink]="['/assets/' + asset['id'] + '/telemetry']"
                      [queryParams]="{ selected: monitoringPoint.id }"
                      (click)="
                        navigateToHierarchyItem(monitoringPoint);
                        $event.stopPropagation()
                      ">
                      <span>
                        <img
                          fxFlex
                          class="icon"
                          [src]="
                            'assets/icons/' +
                            (monitoringPoint.alertStatus === AlertStatus.Clear
                              ? 'clear'
                              : monitoringPoint.alertStatus) +
                            '-icon.svg'
                          " />
                      </span>
                      <span
                        class="ellipsis"
                        matTooltipPosition="above"
                        mat-raised-button
                        matTooltip="{{ monitoringPoint.name }}"
                        [matTooltipDisabled]="isTooltipDisabled(toolTip)"
                        matTooltipClass="customToolTip"
                        #toolTip>
                        {{ monitoringPoint.name }}
                      </span>
                    </a>
                    <div class="online-status">
                      <span>
                        @if (
                          monitoringPoint.meta['isPaused'] &&
                          (flagService.flags$ | async)!['maintenance_mode']
                        ) {
                          <img
                            src="assets/icons/under-maintenance-icon.svg"
                            matTooltipPosition="above"
                            mat-raised-button
                            matTooltip="Alerting Paused"
                            i18n-matTooltip
                            matTooltipClass="customToolTip" />
                        }
                        @if (monitoringPoint.connectionStatus === 'connected') {
                          <img
                            src="assets/icons/online-icon.svg"
                            matTooltipPosition="above"
                            mat-raised-button
                            matTooltip="Connected"
                            i18n-matTooltip
                            matTooltipClass="customToolTip" />
                        }
                        @if (monitoringPoint.connectionStatus !== 'connected') {
                          <img
                            src="assets/icons/offline-icon.svg"
                            matTooltipPosition="above"
                            mat-raised-button
                            matTooltip="Disconnected"
                            i18n-matTooltip
                            matTooltipClass="customToolTip" />
                        }
                      </span>
                    </div>
                  </div>
                }
              }
            }
          }
        }
      }
    </div>
  </div>
} @else {
  <div class="loading">
    <img src="assets/img/bar-loader.gif" />
  </div>
}

@if (resetPopover$ | async) {}
